import Template7 from "template7";
import VerifyPhoneDialogTemplate from "../templates/verify-phone-dialog.t7.html";
//
window.compiledVerifyPhoneDialogTemplate = Template7.compile(VerifyPhoneDialogTemplate);